import { lazy } from "react";

import Spin from "core/ui-kit/spin";

import withSuspenseHoc from "core/HOCs/withSuspense";

const CampaignsContainer = withSuspenseHoc(lazy(() => import("./campaignsContainer")), <Spin />);

import { PERMISSION_ACTION, PERMISSION_RESOURCE } from "core/constants/permission";

import ROUTES from "core/constants/routes/routes";

const CampaignsPageRoute = {
	path: ROUTES.CAMPAIGNS,
	element: CampaignsContainer, 
    permission: { resource: PERMISSION_RESOURCE.MARKETING_TOOLS_CAMPAIGN, action: PERMISSION_ACTION.VIEW }
};

export default CampaignsPageRoute;
